import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popover from './ui/Popover'
import ContentInfo from './ContentInfo'

export default class InfoPopover extends Component {
  static propTypes = {
    model: PropTypes.object.isRequired
  }

  toggle = e => {
    e.preventDefault()
    this.refs.popover.setState({
      showing: !this.refs.popover.showing,
      target: e.target
    })
  }

  render () {
    const {model} = this.props

    return <div style={{display: 'inline-block'}}>
      <a className='btn-icon ion-ios-information-outline' onClick={this.toggle} />
      <Popover placement='bottom center' ref='popover'>
        <ContentInfo content={model} />
      </Popover>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/InfoPopover.js